/**
 * What a ⌘K answer verb does for an open ask. Every answer, risky or not, is sent through the
 * same `answer` the inspector uses; a risky one reaches the signer, which raises the centered
 * passkey prompt (the approval tray) before anything goes out. Other verbs open the inspector.
 */
export interface AskVerbView {
  options: readonly { key: number; id: string; label: string }[]
}

export interface AskVerbDeps<A> {
  send: (answer: A, ok: string) => void
  open: () => void
}

export function askVerbDo<A>(verb: string, view: AskVerbView, d: AskVerbDeps<A>): void {
  if (verb.startsWith('pick')) {
    const o = view.options.find((x) => x.key === Number(verb.slice(4)))
    if (o) d.send({ mode: 'pick' as const, optionId: o.id } as unknown as A, `Answered: ${o.label}`)
  } else if (verb === 'delegate')
    d.send({ mode: 'delegate' as const } as unknown as A, 'The agent decides and reports back')
  else d.open()
}
